export const bulkUploadXlsxHeader = {
  NOMER_AWB: 'Nomer AWB',
  ISI_PAKET: 'Isi Paket',
  VARIASI: 'Variasi',
  JUMLAH_ITEM: 'Jumlah Item (QTY)',
}

export const bulkUploadXlsxHeaderPosition = {
  'Nomer AWB': 'A',
  'Isi Paket': 'B',
  Variasi: 'C',
  'Jumlah Item (QTY)': 'D',
  Packaging: 'E',
}

const defaultFiledClass = {
  thClass: '!capitalize !text-black !font-medium !bg-[#F4F4F4] !py-[16px] !text-base',
  tdClass: '!text-black !text-left',
}

/**
 * Konfigurasi kolom untuk tabel data dari bulk upload
 */
export const tableBulkUploadContentFields = [
  {
    key: 'awb',
    label: 'No AWB',
    ...defaultFiledClass,
  },
  {
    key: 'name',
    label: 'Isi Paket',
    ...defaultFiledClass,
    tdClass: '!text-black min-w-[300px]',
  },
  {
    key: 'variant',
    label: 'Variasi',
    ...defaultFiledClass,
    tdClass: '!text-black min-w-[300px]',
  },
  {
    key: 'quantity',
    label: 'Jumlah Item',
    ...defaultFiledClass,
    tdClass: '!text-black min-w-[200px]',
  },
  {
    key: 'packaging',
    label: 'Bahan Packing',
    ...defaultFiledClass,
    tdClass: '!text-black min-w-[200px]',
  },
  {
    key: 'price',
    label: 'Biaya',
    formatter: value => `Rp ${(value || 0).toLocaleString('id-ID')}`,
    ...defaultFiledClass,
    tdClass: '!text-black min-w-[100px]',
  },
  {
    key: 'action',
    label: 'Action',
    ...defaultFiledClass,
  },
]

export const bulkUploadXlsxErrorFields = [
  {
    key: 'row',
    label: 'Paket',
    formatter: value => `Baris ke-${value}`,
    ...defaultFiledClass,
    tdClass: '!text-black !text-left min-w-[130px]',
  },
  {
    key: 'column',
    label: 'Kolom',
    ...defaultFiledClass,
  },
  {
    key: 'row',
    label: 'Perlu Perbaikan',
    ...defaultFiledClass,
  },
  {
    key: 'message',
    label: 'Alasan',
    ...defaultFiledClass,
  },
]

const pickupErrorMessage = {
  insufficient_balance: 'Saldo tidak mencukupi',
  failed_to_submit: 'Gagal mengajukan packing',
  failed_upload_resi: 'Gagal mengunggah resi',
  no_file_provided: 'Tidak ada file resi',
  component_not_found: 'Sistem error',
}

export const pickupErrorFields = [
  {
    key: 'order',
    label: 'Gudang',
    thClass: `${defaultFiledClass.thClass} text-left`,
    tdClass: defaultFiledClass.tdClass,
  },
  {
    key: 'reason',
    label: 'Detail Error',
    thClass: `${defaultFiledClass.thClass} text-left`,
    tdClass: '!text-black !text-left min-w-[300px]',
    formatter: value => pickupErrorMessage[value],
  },
]

export const chargeType = {
  1: 'Qty',
  2: 'm²',
}

const modalPackingSettingsClass = {
  ...defaultFiledClass,
  tdClass: '!text-black !text-left !px-[16px]',
}

export const fieldsModalPackingSettings = [
  {
    key: 'action',
    label: '',
    thStyle: 'width: 48px;',
    ...modalPackingSettingsClass,
  },
  {
    key: 'name',
    label: 'Jenis Packaging',
    ...modalPackingSettingsClass,
  },
  {
    key: 'layer',
    label: 'Lapis',
    thStyle: 'width: 150px;',
    ...modalPackingSettingsClass,
  },
]

export const statusMapping = {
  Unknown: {
    label: 'Unknown',
    color: {
      main: '#000000',
      sub: '#E2E2E2',
    },
  },
  'Belum Dipacking': {
    label: 'Belum Dipacking',
    color: {
      main: '#4285F4',
      sub: '#D9E7FD',
    },
  },
  Dipacking: {
    label: 'Dipacking',
    color: {
      main: '#FBA63C',
      sub: '#FFF2E2',
    },
  },
  'Menunggu Pickup': {
    label: 'Menunggu Pickup',
    color: {
      main: '#FBBC05',
      sub: '#FEF2CD',
    },
  },
  Dikirim: {
    label: 'Terkirim',
    color: {
      main: '#34A770',
      sub: '#DCF3EB',
    },
  },
  Dibatalkan: {
    label: 'Dibatalkan',
    color: {
      main: '#E31A1A',
      sub: '#FFEDED',
    },
  },
}

export const defaultThClass = 'align-middle text-capitalize font-medium text-[#333333] !text-[14px]'
const defaultTdClass = 'align-middle text-capitalize text-[#333333] !text-[14px]'

export const fieldsHistoryPacking = [
  {
    key: 'id',
    label: 'Outbond ID',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
    thStyle: {
      width: '30px',
    },
    tdStyle: {
      width: '30px',
    },
  },
  {
    key: 'order_date',
    label: 'Tanggal Order',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
    thStyle: {
      minWidth: '230px',
    },
  },
  {
    key: 'warehouse_name',
    label: 'Mitra Gudang',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
    thStyle: {
      minWidth: '240px',
    },
  },
  {
    key: 'total_orders',
    label: 'Jumlah Order',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
    thStyle: {
      minWidth: '160px',
    },
  },
  {
    key: 'total_products',
    label: 'Jumlah Produk',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
    thStyle: {
      minWidth: '180px',
    },
  },
  {
    key: 'status',
    label: 'Status',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
    thStyle: {
      minWidth: '180px',
    },
  },
  {
    key: 'aksi',
    label: 'Aksi',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
    thStyle: {
      minWidth: '170px',
    },
  },
]
